(ns motorsaif.sente
  (:require
   [motorsaif.log :as log]
   [taoensso.encore :as encore]
   [motorsaif.string :as string :refer [format]]
   [reagent.core :as r]
   [motorsaif.url :as url]
   [re-frame.core :as rf]
   [taoensso.sente  :as sente]))

(defonce *socket-vars (atom nil))
(defonce *state-atom (r/atom nil))



(defn chsk [] (:chsk @*socket-vars))
(defn ch-chsk [] (:ch-chsk @*socket-vars))
(defn chsk-send! [& args] (apply (:chsk-send! @*socket-vars) args))
(def **chsk-state (atom (:chsk-state @*socket-vars)))

;; Initialize socket on load


(comment
  (chsk-send! [:query/last-seen 17592186051752] 3000
              (fn [ret]
                (log/info [:qlret ret]))))

(def ^:private limiter
  (encore/rate-limiter
   {:one-per-3s [1 (encore/ms :secs 3)]}))

(defn send-limited! [& args]
  (when-not (limiter :typing)
    (apply chsk-send! args)))

(defn event-msg-handler [{:as ev-msg :keys [id ?data event]}]
  (case id
    :chsk/handshake nil
    :chsk/state (rf/dispatch [:ws-state ev-msg])
    :version/app (rf/dispatch [:check-version ?data])
    :sync/resync-bootstrap (rf/dispatch [:resync-bootstrap-data])
    :sync/online
    (let [{:keys [version users]} ?data]
      ;; (log/info [:sync-users users
      ;;            :version version])
      (rf/dispatch [:check-version version])
      (rf/dispatch [:assoc-data :online-users users]))
    :thread/touch (rf/dispatch [:update-thread-touched ?data])
    :message/typing (let [{:keys [from-id thread-id]} ?data]
                      (log/info [:typing ?data])
                      (rf/dispatch [:typing-status ?data]))
    :message/new (let [{:keys [handle body media thread-id]} ?data]
                   ;; TODO thread-id not present
                   (log/info [:new-msg ?data])
                   (rf/dispatch [:fetch-messages {:status :active}]))
    :message/edit (let [{:keys [handle body media thread-id]} ?data]
                   ;; TODO thread-id not present
                   (log/info [:edit-msg ?data])
                   (rf/dispatch [:fetch-messages {:status :active}]))
    :message/delete (let [{:keys [handle body media thread-id]} ?data]
                   ;; TODO thread-id not present
                   (log/info [:edit-msg ?data])
                   (rf/dispatch [:fetch-messages {:status :active}]))
    :interaction-status/update
    (let [{:keys [thread-id]} ?data]
      (rf/dispatch [:get-interaction-status thread-id]))
    :request/new (let [{{:car/keys [make model year]} :request/object} ?data
                       text (format "A %s %s %s needs repairing" year make model)]

                   (rf/dispatch [:fetch-requests])
                   #_(js/Notification. "New Request" #js {:body text}))
    (log/info [:ws-unhandled id :data ?data])))

(defonce *router (atom nil))
(defn stop-router! [] (when-let [stop-f @*router] (stop-f)))
(defn start-router!
  "Calling again when started will restart"
  []
  (stop-router!)
  (reset! *router
          (sente/start-client-chsk-router!
           (:ch-chsk @*socket-vars)
           event-msg-handler)))

(defn init-socket! [opts]
  (log/debug [:init-socket opts])
  ;; Cleanup existing socket
  (when-let [s (chsk)]
    (sente/chsk-disconnect! s))

  (let [{:keys [csrf-token]} opts
        opts (dissoc opts :csrf-token)
        {:keys [chsk ch-recv send-fn state stop-fn]}
        (sente/make-channel-socket-client! "/ws"
                                           csrf-token
                                           (merge {:type :auto
                                                   :ws-kalive-ms 5000} opts))
        ret {:chsk chsk
             :ch-chsk ch-recv
             :chsk-send! send-fn
             :chsk-state state}]
    (add-watch state :chsk-state
               (fn [_ _ _ new-state]
                 (reset! *state-atom new-state)))
    (reset! *socket-vars ret)
    (log/info "Sente loaded")
    ret)

  (start-router!))
